// helpers
import VScope from '../components/helpers/v-scope.vue';
import VSource from '../components/helpers/v-source.vue';
import VModelSource from '../components/helpers/v-model-source.vue';
import VLoader from '../components/helpers/v-loader.vue';
import VSvgIcon from '../components/helpers/v-svg-icon.vue';
import VVideo from '../components/helpers/v-video.vue';
import VLazyComponent from '../components/helpers/v-lazy-component.vue';

// plugins
import VSwiperSlider from '../components/v-swiper-slider.vue'; // https://swiperjs.com/vue/

// forms
import VForm from '../components/v-form.vue';
import VField from '../components/v-field.vue';
import VFieldText from '../components/v-field-text.vue';
import VFieldCheckbox from '../components/v-field-checkbox.vue';
import VFieldCheckList from '../components/v-field-check-list.vue';

// blocks
import VPageHeader from '../components/v-page-header.vue';
import VMainNav from '../components/v-main-nav.vue';
import VContact from '../components/v-contact.vue';
import VMainBanner from '../components/v-main-banner.vue';
import VGridBanner from '../components/v-grid-banner.vue';
import VBgBanner from '../components/v-bg-banner.vue';
import VInfoBanner from '../components/v-info-banner.vue';
import VBrandSlider from '../components/v-brand-slider.vue';
import VPageFooter from '../components/v-page-footer.vue';
import VContactList from '../components/v-contact-list.vue';
import VSocials from '../components/v-socials.vue';
import VLegalInfo from '../components/v-legal-info.vue';
import VPage404 from '../components/v-page-404.vue';
import VHeroBanner from '../components/v-hero-banner.vue';
import VArticle from '../components/v-article.vue';
import VLinkWidget from '../components/v-link-widget.vue';
import VInfoSection from "../components/v-info-section.vue";
import VAccordion from "../components/v-accordion.vue";
import VInfoProduct from "../components/v-info-product.vue";
import VBannerGrid from "../components/v-banner-grid.vue";
import VPartnerAndGeo from "../components/v-partner-and-geo.vue";
import VBonus from "../components/v-bonus.vue";
import VSectionTable from "../components/v-section-table.vue";

export default {
	// helpers
	'v-scope': VScope,
	'v-source': VSource,
	'v-model-source': VModelSource,
	'v-loader': VLoader,
	'v-svg-icon': VSvgIcon,
	'v-video': VVideo,
	'v-lazy-component': VLazyComponent,

	// plugins
	'v-swiper-slider': VSwiperSlider,

	// forms
	'v-form': VForm,
	'v-field': VField,
	'v-field-text': VFieldText,
	'v-field-checkbox': VFieldCheckbox,
	'v-field-check-list': VFieldCheckList,

	// blocks
	'v-page-header': VPageHeader,
	'v-main-nav': VMainNav,
	'v-contact': VContact,
	'v-main-banner': VMainBanner,
	'v-grid-banner': VGridBanner,
	'v-bg-banner': VBgBanner,
	'v-info-banner': VInfoBanner,
	'v-brand-slider': VBrandSlider,
	'v-page-footer': VPageFooter,
	'v-contact-list': VContactList,
	'v-socials': VSocials,
	'v-legal-info': VLegalInfo,
	'v-page-404': VPage404,
	'v-hero-banner': VHeroBanner,
	'v-article': VArticle,
	'v-link-widget': VLinkWidget,
	'v-info-section': VInfoSection,
	'v-accordion': VAccordion,
	'v-info-product': VInfoProduct,
	'v-banner-grid': VBannerGrid,
	'v-partner-and-geo': VPartnerAndGeo,
	'v-bonus': VBonus,
	'v-section-table': VSectionTable,
};